import { render, staticRenderFns } from "./workfile-add-batch.vue?vue&type=template&id=0f7dec90&scoped=true"
import script from "./workfile-add-batch.vue?vue&type=script&lang=js"
export * from "./workfile-add-batch.vue?vue&type=script&lang=js"
import style0 from "./workfile-add-batch.vue?vue&type=style&index=0&id=0f7dec90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7dec90",
  null
  
)

export default component.exports